var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: "VIEW_PORTFOLIO",
          expression: "'VIEW_PORTFOLIO'",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c("portfolio-widget-row", { ref: "portfolioWidgetRow" }),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "5" } }, [
                _c(
                  "h4",
                  {
                    staticClass: "card-title mb-0",
                    attrs: { id: "chart-portfolio-vulns" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.portfolio_vulnerabilities")) +
                        "\n        "
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "small text-muted" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.last_measurement")) +
                        ": " +
                        _vm._s(_vm.lastMeasurement)
                    ),
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "PORTFOLIO_MANAGEMENT",
                            expression: "'PORTFOLIO_MANAGEMENT'",
                          },
                        ],
                        staticClass: "font-weight-bold",
                        staticStyle: { "margin-left": "6px" },
                        on: { click: _vm.refreshMetrics },
                      },
                      [_c("i", { staticClass: "fa fa-refresh" })]
                    ),
                  ],
                  1
                ),
              ]),
              _c("b-col", {
                staticClass: "d-none d-md-block",
                attrs: { sm: "7" },
              }),
            ],
            1
          ),
          _c("chart-portfolio-vulnerabilities", {
            ref: "chartPortfolioVulnerabilities",
            staticClass: "chart-wrapper",
            staticStyle: { height: "200px", "margin-top": "40px" },
            attrs: { chartId: "chartPortfolioVulnerabilities", height: 200 },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "b-row",
                { staticClass: "text-center" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-sm-2 mb-0" },
                    [
                      _c("div", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("severity.critical"))),
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.critical) +
                            " (" +
                            _vm._s(_vm.criticalPercent) +
                            "%)"
                        ),
                      ]),
                      _c("b-progress", {
                        staticClass: "progress-xs mt-2 severity-critical",
                        attrs: {
                          height: "{}",
                          precision: 1,
                          value: _vm.criticalPercent,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-sm-2 mb-0" },
                    [
                      _c("div", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("severity.high"))),
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.high) +
                            " (" +
                            _vm._s(_vm.highPercent) +
                            "%)"
                        ),
                      ]),
                      _c("b-progress", {
                        staticClass: "progress-xs mt-2 severity-high",
                        attrs: {
                          height: "{}",
                          precision: 1,
                          value: _vm.highPercent,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-sm-2 mb-0" },
                    [
                      _c("div", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("severity.medium"))),
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.medium) +
                            " (" +
                            _vm._s(_vm.mediumPercent) +
                            "%)"
                        ),
                      ]),
                      _c("b-progress", {
                        staticClass: "progress-xs mt-2 severity-medium",
                        attrs: {
                          height: "{}",
                          precision: 1,
                          value: _vm.mediumPercent,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-sm-2 mb-0" },
                    [
                      _c("div", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("severity.low"))),
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.low) + " (" + _vm._s(_vm.lowPercent) + "%)"
                        ),
                      ]),
                      _c("b-progress", {
                        staticClass: "progress-xs mt-2 severity-low",
                        attrs: {
                          height: "{}",
                          precision: 1,
                          value: _vm.lowPercent,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-sm-2 mb-0" },
                    [
                      _c("div", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("severity.unassigned"))),
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.unassigned) +
                            " (" +
                            _vm._s(_vm.unassignedPercent) +
                            "%)"
                        ),
                      ]),
                      _c("b-progress", {
                        staticClass: "progress-xs mt-2 status-failed",
                        attrs: {
                          height: "{}",
                          precision: 1,
                          value: _vm.unassignedPercent,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-policy-violations-state" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.policy_violations")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.policy_violations_by_state")
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-policy-violations-state", {
                    ref: "chartPolicyViolationsState",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartPolicyViolationsState",
                      height: 200,
                    },
                  }),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("policy_violation.fails"))
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.failViolations) +
                                    " (" +
                                    _vm._s(_vm.failViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-failed",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.failViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("policy_violation.warns"))
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.warnViolations) +
                                    " (" +
                                    _vm._s(_vm.warnViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-warning",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.warnViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("policy_violation.infos"))
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.infoViolations) +
                                    " (" +
                                    _vm._s(_vm.infoViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-info",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.infoViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: {
                              id: "chart-policy-violations-classification",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.policy_violations")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "message.policy_violations_by_classification"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-policy-violations-classification", {
                    ref: "chartPolicyViolationsClassification",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartPolicyViolationsClassification",
                      height: 200,
                    },
                  }),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("policy_violation.security")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.securityViolations) +
                                    " (" +
                                    _vm._s(_vm.securityViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-failed",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.securityViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("policy_violation.operational")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.operationalViolations) +
                                    " (" +
                                    _vm._s(_vm.operationalViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-warning",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.operationalViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("policy_violation.license")) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.licenseViolations) +
                                    " (" +
                                    _vm._s(_vm.licenseViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-info",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.licenseViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-auditing-findings-progress" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.auditing_progress")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(_vm._s(_vm.$t("message.findings"))),
                        ]),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-auditing-findings-progress", {
                    ref: "chartAuditingFindingsProgress",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartAuditingFindingsProgress",
                      height: 200,
                    },
                  }),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("message.findings_unaudited")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.unauditedFindings) +
                                    " (" +
                                    _vm._s(_vm.unauditedFindingsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass:
                                  "progress-xs mt-2 severity-unassigned",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.unauditedFindingsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("message.findings_audited")) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.auditedFindings) +
                                    " (" +
                                    _vm._s(_vm.auditedFindingsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 severity-low",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.auditedFindingsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-auditing-violations-progress" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.auditing_progress")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.policy_violations")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-auditing-violations-progress", {
                    ref: "chartAuditingViolationsProgress",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartAuditingViolationsProgress",
                      height: 200,
                    },
                  }),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("message.violations_unaudited")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.unauditedViolations) +
                                    " (" +
                                    _vm._s(_vm.unauditedViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass:
                                  "progress-xs mt-2 severity-unassigned",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.unauditedViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("message.violations_audited")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.auditedViolations) +
                                    " (" +
                                    _vm._s(_vm.auditedViolationsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 severity-low",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.auditedViolationsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-projects" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.projects")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-project-vulnerabilities", {
                    ref: "chartProjectVulnerabilities",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartProjectVulnerabilities",
                      height: 200,
                    },
                  }),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("message.non_vulnerable"))
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.nonVulnerableProjects) +
                                    " (" +
                                    _vm._s(_vm.nonVulnerableProjectsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-passed",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.nonVulnerableProjectsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.$t("message.vulnerable"))),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.vulnerableProjects) +
                                    " (" +
                                    _vm._s(_vm.vulnerableProjectsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-warning",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.vulnerableProjectsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-components" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.components")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-component-vulnerabilities", {
                    ref: "chartComponentVulnerabilities",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartComponentVulnerabilities",
                      height: 200,
                    },
                  }),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("message.non_vulnerable"))
                                ),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.nonVulnerableComponents) +
                                    " (" +
                                    _vm._s(_vm.nonVulnerableComponentsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-passed",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.nonVulnerableComponentsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-sm-2 mb-0" },
                            [
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.$t("message.vulnerable"))),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.vulnerableComponents) +
                                    " (" +
                                    _vm._s(_vm.vulnerableComponentsPercent) +
                                    "%)"
                                ),
                              ]),
                              _c("b-progress", {
                                staticClass: "progress-xs mt-2 status-warning",
                                attrs: {
                                  height: "{}",
                                  precision: 1,
                                  value: _vm.vulnerableComponentsPercent,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-card",
                { attrs: { header: _vm.$t("message.portfolio_statistics") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "info" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.projects"))
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.totalProjects)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "danger" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.vulnerable_projects"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.vulnerableProjects)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "info" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.components"))
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.totalComponents)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "danger" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.vulnerable_components"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(
                                          _vm._s(_vm.vulnerableComponents)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "danger" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.portfolio_vulnerabilities"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.vulnerabilities)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "warning" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.suppressed"))
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.suppressed)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "info" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.policy_violations"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.totalViolations)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "info" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("policy_violation.license")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.licenseViolations)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "info" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "policy_violation.operational"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(
                                          _vm._s(_vm.operationalViolations)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c(
                                    "Callout",
                                    { attrs: { variant: "info" } },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "policy_violation.security"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c("strong", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.securityViolations)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }